import { render, staticRenderFns } from "./ApplicantViewUpdate.vue?vue&type=template&id=209073f2&scoped=true"
import script from "./ApplicantViewUpdate.vue?vue&type=script&lang=ts"
export * from "./ApplicantViewUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209073f2",
  null
  
)

export default component.exports